<template>
  <div class="feng-tuoyuan-result" :class="{ 'is-authentic': antiQueryLoaded && isAuthentic, 'is-error': !antiQueryLoaded || !isAuthentic }">
    <div v-if="antiQueryLoaded && isAuthentic" class="success-main">
      <div class="page-header">
        <img class="brand-logo" src="/static/images/fty/logo.png" alt="丰驼源 logo">
      </div>

      <div class="result-card">
        <img class="status-icon" src="/static/images/fty/yztg.png" alt="验证通过">
        <div class="status-desc">您查询的产品为丰驼源正品，请放心饮用。</div>

        <div class="info-block">
          <div class="info-row">
            <span class="info-label">产品名称：</span>
            <span class="info-value">{{ productName }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">产品型号：</span>
            <span class="info-value">{{ productModel }}</span>
          </div>
        </div>

        <div class="query-time">{{ currentTime }}</div>
      </div>
    </div>

    <div v-if="antiQueryLoaded && isAuthentic" class="success-actions">
      <div class="primary-action" @click="goActivity">
        <img class="primary-action-img" src="/static/images/fty/lqjf.png" alt="领取积分参与活动">
      </div>

      <div class="bottom-actions">
        <div class="bottom-action" @click="goTrace">
          <img class="bottom-action-img" src="/static/images/fty/query-sy.png" alt="查看溯源信息">
        </div>
        <wx-open-launch-weapp
          class="bottom-action"
          :appid="miniAppId"
          :username="miniAppOriginalId"
          :path="miniAppPage"
        >
          <script type="text/wxtag-template">
            <img
              src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/white-go-shop-8b93bea3b4b64219afd63bc0a1363262.png"
              alt="进入官方商城"
              style="display:block;width:100%;height:auto;"
            />
          </script>
        </wx-open-launch-weapp>
      </div>
    </div>

    <div v-else-if="antiQueryLoaded" class="fty-error-page">
      <div class="fty-error-banner">
        <img class="fty-error-banner-img" src="/static/images/fty/banner.png" alt="丰驼源 banner">
        <img class="fty-error-logo" src="/static/images/fty/logo.png" alt="丰驼源 logo">
      </div>

      <div class="fty-error-content">
        <img class="fty-error-icon" src="/static/images/fty/gantan.png" alt="异常提示">
        <div class="fty-error-title">您查询的数码不存在</div>

        <div class="fty-error-card">
          <div class="fty-error-code-label">查询数码：</div>
          <div class="fty-error-code-value">{{ queryCode }}</div>
          <div class="fty-error-divider"></div>
          <div class="fty-error-tip">请核对后重新输入</div>
        </div>

        <button class="fty-error-retry-btn" type="button" @click="goScan">重新输入</button>

        <wx-open-launch-weapp
          class="fty-error-shop-entry"
          :appid="miniAppId"
          :username="miniAppOriginalId"
          :path="miniAppPage"
        >
          <script type="text/wxtag-template">
            <img
              src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/to-shop-a1bbed85527840e2b7f70d80ae7f8498.png"
              alt="前往商城"
              style="display:block;width:100%;height:auto;"
            />
          </script>
        </wx-open-launch-weapp>
      </div>
    </div>
  </div>
</template>

<script>
import { getAntiData, getInfoByCode, getJSSDK, getScoreConfig, getTemplate, getWechatAuth } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'FengTuoYuanResult',
  data() {
    return {
      appId: process.env.ENV_NUM === '1' ? 'wx75dda783f234b0a9' : 'wx885161c495be58a3',
      eno: process.env.ENV_NUM === '1' ? '138242667734' : '138799163677',
      rawCode: '',
      deptId: '',
      isWxReady: false,
      scoreConfig: null,
      shopUrl: '',
      miniAppId: '',
      miniAppOriginalId: '',
      miniAppPage: '',
      activityId: '',
      antiQueryLoaded: false,
      antiResultResponse: null,
      antiResultData: null,
      antiResultCode: '',
      antiResultMessage: '',
      isAuthentic: true,
      productName: '',
      productModel: '',
      currentTime: '',
      timer: null
    }
  },
  computed: {
    queryCode() {
      return String(this.rawCode || '').slice(0, 16)
    }
  },
  mounted() {
    this.rawCode = this.$route.query.c || ''
    this.updateCurrentTime()
    this.getWxJs()
    this.loadAntiResult()
    this.timer = setInterval(() => {
      this.updateCurrentTime()
    }, 1000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    goScan() {
      this.$router.push('/fty/scan')
    },
    async goActivity() {
      if (!this.deptId) {
        alert('暂无可参与的活动')
        return
      }
      const activityId = await this.loadTemplate()
      if (!activityId) {
        alert('暂无可参与的活动')
        return
      }
      const redirectUrl = `${window.location.origin}/fty/activity`
      const params = new URLSearchParams()
      params.append('c', this.rawCode || this.queryCode)
      const fullRedirectUrl = `${redirectUrl}?${params.toString()}`
      getWechatAuth(encodeURIComponent(fullRedirectUrl), this.appId, 1).then(res => {
        const data = res.data
        window.location.href = data
      }).catch(err => {
        console.error('获取微信授权失败:', err)
        alert('获取微信授权失败，请稍后重试')
      })
    },
    goTrace() {
      this.$router.push({
        path: '/fty/trace',
        query: {
          c: this.rawCode || this.queryCode
        }
      })
    },
    async loadAntiResult() {
      if (!this.queryCode) {
        this.antiQueryLoaded = true
        return
      }
      try {
        const res = await getAntiData(this.queryCode, this.eno)
        const responseData = res && res.data ? res.data : null
        this.antiResultResponse = responseData
        this.antiResultData = responseData && responseData.data ? responseData.data : null
        this.antiResultCode = responseData && responseData.code ? responseData.code : ''
        this.antiResultMessage = responseData && responseData.message ? responseData.message : ''
        this.deptId = this.antiResultData && this.antiResultData.deptId ? String(this.antiResultData.deptId) : ''
        if (this.deptId) {
          await this.loadScoreConfig()
        }
        this.isAuthentic = this.antiResultCode === '300101' || this.antiResultCode === '300102'
        if (this.isAuthentic) {
          await this.queryCodeInfo()
        }
        this.antiQueryLoaded = true
        console.log('FengTuoYuan anti query result:', responseData)
      } catch (err) {
        this.antiResultResponse = null
        this.antiResultData = null
        this.antiResultCode = ''
        this.antiResultMessage = ''
        this.deptId = ''
        this.scoreConfig = null
        this.shopUrl = ''
        this.miniAppId = ''
        this.miniAppOriginalId = ''
        this.miniAppPage = ''
        this.isAuthentic = false
        this.antiQueryLoaded = true
        console.error('丰驼源防伪查询失败:', err)
      }
    },
    async loadScoreConfig() {
      try {
        const res = await getScoreConfig(this.deptId)
        const data = res && res.data ? res.data.data : null
        this.scoreConfig = data
        this.shopUrl = data && data.shopUrl ? data.shopUrl : ''
        if (this.shopUrl) {
          const shopInfo = this.shopUrl.split('|')
          this.miniAppId = shopInfo[0] || ''
          this.miniAppOriginalId = shopInfo[1] || ''
          this.miniAppPage = shopInfo[2] || ''
        } else {
          this.miniAppId = ''
          this.miniAppOriginalId = ''
          this.miniAppPage = ''
        }
      } catch (error) {
        this.scoreConfig = null
        this.shopUrl = ''
        this.miniAppId = ''
        this.miniAppOriginalId = ''
        this.miniAppPage = ''
        console.error('获取积分配置失败:', error)
      }
    },
    async loadTemplate() {
      try {
        const res = await getTemplate(this.deptId)
        const data = res && res.data ? res.data.data : null
        this.activityId = data && data.activityId ? String(data.activityId) : ''
        return this.activityId
      } catch (error) {
        this.activityId = ''
        console.error('获取活动模板失败:', error)
        return ''
      }
    },
    async queryCodeInfo() {
      try {
        const res = await getInfoByCode(this.queryCode)
        const data = res && res.data ? res.data : null
        if (data && data.code === '200' && data.data) {
          this.productName = data.data.productName || ''
          this.productModel = data.data.productNo || ''
        }
      } catch (error) {
        console.error('获取产品信息失败:', error)
      }
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app'],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideMenuItems',
            'showOptionMenu',
            'hideOptionMenu',
            'closeWindow',
            'scanQRCode'
          ]
        })
        wx.ready(() => {
          this.isWxReady = true
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          })
        })
        wx.error(err => {
          this.isWxReady = false
          console.error('微信 JS-SDK 初始化失败:', err)
        })
      }).catch(err => {
        this.isWxReady = false
        console.error('获取微信 JS-SDK 失败:', err)
        alert('获取微信授权失败，请稍后重试')
      })
    },
    updateCurrentTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      this.currentTime = `${year}-${month}-${day}    ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
.feng-tuoyuan-result {
  height: 100vh;
  padding: clamp(10px, 2.6vw, 16px) 0 clamp(14px, 3.8vw, 20px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  overflow: hidden;
}

.feng-tuoyuan-result.is-authentic {
  background: rgb(76, 189, 200);
}

.feng-tuoyuan-result.is-error {
  background: #ffffff;
}

.success-main {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(30px, 7vw, 42px);
}

.page-header {
  display: flex;
  justify-content: center;
  width: 100%;
}

.brand-logo {
  display: block;
  width: clamp(118px, 30vw, 154px);
  height: auto;
}

.result-card {
  width: 86vw;
  max-width: 440px;
  padding: clamp(26px, 6vw, 34px) clamp(18px, 5vw, 26px) clamp(22px, 5.4vw, 28px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: clamp(26px, 6.5vw, 36px);
  background: rgb(249, 250, 251);
}

.status-icon {
  display: block;
  width: clamp(88px, 22vw, 118px);
  height: auto;
}

.status-desc {
  margin-top: clamp(14px, 3.6vw, 18px);
  text-align: center;
  font-size: clamp(13px, 3.8vw, 17px);
  line-height: 1.7;
  color: #333333;
}

.info-block {
  width: 100%;
  margin-top: clamp(22px, 5vw, 30px);
  padding-left: clamp(6px, 1.4vw, 10px);
  box-sizing: border-box;
}

.info-row {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: clamp(12px, 3.5vw, 16px);
  line-height: 1.65;
  color: #4a4a4a;
}

.info-label {
  flex: 0 0 auto;
  width: clamp(78px, 18vw, 92px);
  text-align: left;
  white-space: nowrap;
}

.info-value {
  flex: 1 1 auto;
  max-width: none;
  font-weight: 600;
  color: #333333;
  word-break: break-all;
}

.query-time {
  margin-top: clamp(20px, 4.5vw, 28px);
  text-align: center;
  font-size: clamp(12px, 3.4vw, 16px);
  line-height: 1.4;
  color: #555555;
}

.success-actions {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: clamp(22px, 5vw, 34px);
}

.primary-action {
  width: 90vw;
  max-width: 460px;
}

.primary-action-img {
  display: block;
  width: 100%;
  height: auto;
}

.bottom-actions {
  width: 90vw;
  max-width: 460px;
  margin-top: clamp(12px, 3vw, 16px);
  display: flex;
  gap: clamp(10px, 2.8vw, 14px);
}

.bottom-action {
  flex: 1;
}

.bottom-action-img {
  display: block;
  width: 100%;
  height: auto;
}

@media (max-height: 667px) {
  .brand-logo {
    width: 110px;
  }

  .result-card {
    padding: 22px 16px 18px;
  }

  .status-icon {
    width: 82px;
  }

  .status-desc {
    margin-top: 10px;
    font-size: 13px;
  }

  .info-block {
    margin-top: 16px;
  }

  .info-row {
    font-size: 12px;
  }

  .query-time {
    margin-top: 16px;
    font-size: 12px;
  }

  .bottom-actions {
    margin-top: 10px;
    gap: 10px;
  }
}

@media (max-height: 568px) {
  .feng-tuoyuan-result {
    padding: 6px 0 10px;
    justify-content: space-between;
  }

  .success-main {
    gap: 14px;
  }

  .brand-logo {
    width: 94px;
  }

  .result-card {
    width: 84vw;
    max-width: 380px;
    padding: 16px 14px 14px;
    border-radius: 24px;
  }

  .status-icon {
    width: 68px;
  }

  .status-desc {
    margin-top: 8px;
    font-size: 12px;
    line-height: 1.55;
  }

  .info-block {
    margin-top: 12px;
  }

  .info-row {
    font-size: 12px;
    line-height: 1.55;
  }

  .info-label {
    width: 82px;
  }

  .query-time {
    margin-top: 12px;
    font-size: 12px;
  }

  .primary-action {
    width: 86vw;
  }

  .bottom-actions {
    width: 86vw;
    margin-top: 8px;
    gap: 8px;
  }

  .success-actions {
    margin-top: 6px;
  }
}

.fty-error-page {
  width: 100%;
  height: 100%;
  background: #ffffff;
  overflow: hidden;
}

.fty-error-banner {
  position: relative;
  width: 100%;
  overflow: hidden;
  border-bottom-left-radius: clamp(28px, 6.4vw, 40px);
  border-bottom-right-radius: clamp(28px, 6.4vw, 40px);
}

.fty-error-banner-img {
  display: block;
  width: 100%;
  height: clamp(170px, 31vh, 260px);
  object-fit: cover;
  object-position: center;
}

.fty-error-logo {
  position: absolute;
  left: 50%;
  bottom: clamp(14px, 3.8vw, 22px);
  width: clamp(112px, 33vw, 132px);
  transform: translateX(-50%);
}

.fty-error-content {
  min-height: calc(100vh - clamp(170px, 31vh, 260px));
  padding: clamp(26px, 7vw, 34px) clamp(16px, 5.4vw, 22px) clamp(24px, 7vw, 32px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fty-error-icon {
  display: block;
  width: clamp(48px, 13vw, 58px);
  height: auto;
}

.fty-error-title {
  margin-top: clamp(18px, 4.5vw, 24px);
  font-size: clamp(16px, 4.8vw, 20px);
  line-height: 1.35;
  font-weight: 600;
  color: #4a4a4a;
  text-align: center;
}

.fty-error-card {
  width: 72vw;
  margin-top: clamp(24px, 6vw, 34px);
  padding: clamp(22px, 6vw, 30px) clamp(18px, 5vw, 26px);
  box-sizing: border-box;
  border-radius: clamp(18px, 5vw, 24px);
  background: #b7b7b7;
}

.fty-error-code-label {
  font-size: clamp(14px, 4vw, 18px);
  line-height: 1.4;
  font-weight: 700;
  color: #ffffff;
}

.fty-error-code-value {
  margin-top: clamp(10px, 2.8vw, 14px);
  font-size: clamp(11px, 3.3vw, 15px);
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.95);
  word-break: break-all;
}

.fty-error-divider {
  width: 100%;
  height: 1px;
  margin-top: clamp(22px, 5.5vw, 30px);
  background: rgba(255, 255, 255, 0.35);
}

.fty-error-tip {
  margin-top: clamp(18px, 4.5vw, 24px);
  text-align: center;
  font-size: clamp(12px, 3.8vw, 15px);
  line-height: 1.4;
  font-weight: 600;
  color: #ffffff;
}

.fty-error-retry-btn {
  width: 50vw;
  height: clamp(44px, 12vw, 54px);
  margin-top: clamp(26px, 7vw, 36px);
  border: 0;
  border-radius: clamp(16px, 4.8vw, 22px);
  background: rgb(76, 189, 200);
  color: #ffffff;
  font-size: clamp(14px, 4.2vw, 17px);
  font-weight: 600;
}

.fty-error-shop-entry {
  width: 50vw;
  max-width: 100%;
  margin-top: clamp(18px, 5vw, 28px);
  display: flex;
  justify-content: center;
}

.fty-error-shop-entry-img {
  display: block;
  width: 100%;
  height: auto;
}

@media (max-height: 568px) {
  .fty-error-banner-img {
    height: 138px;
  }

  .fty-error-logo {
    width: 98px;
    bottom: 10px;
  }

  .fty-error-content {
    min-height: calc(100vh - 138px);
    padding: 14px 14px 16px;
  }

  .fty-error-icon {
    width: 40px;
  }

  .fty-error-title {
    margin-top: 10px;
    font-size: 15px;
  }

  .fty-error-card {
    width: 68vw;
    margin-top: 16px;
    padding: 16px 16px 14px;
    border-radius: 18px;
  }

  .fty-error-code-label {
    font-size: 14px;
  }

  .fty-error-code-value {
    margin-top: 8px;
    font-size: 11px;
    line-height: 1.35;
  }

  .fty-error-divider {
    margin-top: 14px;
  }

  .fty-error-tip {
    margin-top: 12px;
    font-size: 12px;
  }

  .fty-error-retry-btn {
    width: 46vw;
    height: 38px;
    margin-top: 16px;
    border-radius: 16px;
    font-size: 14px;
  }

  .fty-error-shop-entry {
    width: 46vw;
    margin-top: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FengTuoYuan/Result.vue